import { FC } from 'react';
import { useIntl } from 'react-intl';
import { TENANT_NAME } from '../../../../tenant/tenant-names';

export const Workflow: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <div>
      <p style={{ marginBottom: 40 }}>
        {formatMessage({ id: 'home.info.1.text' }, { tenant: TENANT_NAME })}
      </p>
      {/*<span*/}
      {/*  className={styles.button}*/}
      {/*  style={{ float: "left" }}*/}
      {/*  onClick={() => router.push("/workflow")}*/}
      {/*>*/}
      {/*  {formatMessage({ id: "home.data-security.more" })}*/}
      {/*</span>*/}
    </div>
  );
};
